export type AdminFeatureFlagState = 'enabled' | 'disabled' | 'beta' | 'internal-only';

export const ADMIN_FEATURE_FLAGS = {
  coreOverview: 'enabled',
  globalAnalytics: 'enabled',
  liveMetrics: 'beta',
  activityFeed: 'enabled',
  eventOperations: 'enabled',
  userManagement: 'enabled',
  financialControl: 'enabled',
  communicationCenter: 'enabled',
  contentPlatform: 'enabled',
  securityCompliance: 'beta',
  systemConfiguration: 'enabled',
  aiAutomation: 'beta',
  fraudIntelligence: 'internal-only',
  environmentControls: 'internal-only',
  legacyDisabled: 'disabled',
} as const satisfies Record<string, AdminFeatureFlagState>;

export type AdminFeatureFlagKey = keyof typeof ADMIN_FEATURE_FLAGS;

export type FeatureFlagContext = {
  isInternalUser?: boolean;
};

export function isFeatureFlagVisible(
  flagKey: AdminFeatureFlagKey | undefined,
  context: FeatureFlagContext = {}
): boolean {
  if (!flagKey) return true;
  const state = ADMIN_FEATURE_FLAGS[flagKey];
  if (state === 'enabled' || state === 'beta') return true;
  if (state === 'disabled') return false;
  return Boolean(context.isInternalUser);
}
